import { Action } from "../../types"

const initialState: any = {
    role: localStorage.getItem("role")
      ? JSON.parse(localStorage.getItem("role")!)
      : {
          id: "",
          label: "",
        },
  };
  
export function roleReducer(state:any=initialState,action:Action<any>):any{
    switch(action.type){
        case "setCurrentRole":
            const updatedRole = action.payload;
            localStorage.setItem("role", JSON.stringify(updatedRole));
            return {
                ...state,
                role: action.payload,
            };
        default:
            return state;
    }
    return state
}
